import React, { useEffect, useState } from "react";
import "./analytics.css";
import Refund from "./refund/refund";
import DownloadAndDropdown from "./downloadAndDropdown";
import TabSchema from "../tabSchema";
import AnalyticsContext from "./analyticsContext";
import RefreshContext from "./checkout/refreshContext";
import { useAuth } from "../../context/API_Client";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import { PaymentLinkAnalyticsProvider } from "./paymentLinkAnalytics/paymentLinkAnalyticsContext";
import { ChekoutAnalyticsProvider } from "./checkout/CheckoutContext";
import { OverviewAnalyticsProvider } from "./overview/OverviewContext";
import { RefundAnalyticsProvider } from "./refund/RefundContext";
import { OffersAnalyticsProvider } from "./offers/OffersAnalyticsContext";
import { sortArrayValue } from "../utils/utils";

export default function Analytics() {
  const showDownloadIcon = false;
  const showRefreshIcon = true;
  const showDropdown = true;
  const showCurrency = true;
  const showBusinessUnit = true;

  const [refresh, setRefresh] = useState(false);
  const [singleStartDate, setSingleStartDate] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [selectedDropdownValue, setSelectedDropdownValue] = useState(
    localStorage.getItem("selectedDropdownValue") || "today"
  );
  const { getAllModalData, postPspConfigForFiltering } = useAuth();

  const handleDropdownChange = (value) => {
    setSelectedDropdownValue(value);
    // if (value !== "customDate")
    localStorage.setItem("selectedDropdownValue", value);
  };

  const handleRefreshButton = () => {
    setRefresh(!refresh);
  };

  const [configPaymentData, setConfigPaymentData] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [filteredCurrency, setFilteredCurrency] = useState([]);
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState("");
  const [selectedFilterCurrency, setSelectedFilterCurrency] = useState(
    localStorage.getItem("selectedFilterCurrency") || ""
  );
  const [loading, setLoading] = useState(true);

  const handleBussinessUnitChange = (businessUnit) => {
    setSelectedBusinessUnit(businessUnit);
  };

  const handleCurrencyFilterChange = (currencyValue) => {
    setSelectedFilterCurrency(currencyValue);
    localStorage.setItem("selectedFilterCurrency", currencyValue);
  };
  const handleSingleStartDate = (data) => {
    setSingleStartDate(data);
  };

  const handleStartDate = (data) => {
    setStartDate(data);
  };
  const handleEndDate = (data) => {
    setendDate(data);
  };
  useEffect(() => {
    postPspConfigForFiltering(
      {},
      function (data) {

        let businessUnit = []

        if (data?.legalEntities?.length) {

          businessUnit = sortArrayValue(data?.legalEntities, 'name')


        }
        setConfigPaymentData(businessUnit);
        setLoading(false);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
        setLoading(false);
      }
    );
    getAllModalData(
      function (data) {
        setCurrency(data?.currencyCodes);
        setLoading(false);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
        setLoading(false);
      }
    );
  }, []);

  useEffect(() => {
    if (selectedBusinessUnit?.length > 0) {
      postPspConfigForFiltering(
        {
          legalEntities: selectedBusinessUnit,
        },
        function (data) {
          let filterCurrencies = []
          if (data?.currencyCodes?.length) {
            filterCurrencies = sortArrayValue(data?.currencyCodes, 'title')
          }
          setFilteredCurrency(filterCurrencies);
          setLoading(false);
        },
        function (errMsg) {
          customToast("error", "high", errMsg);
          setLoading(false);
        }
      );
    }
  }, [selectedBusinessUnit]);

  const analyticsTabs = [
    {
      label: "Overview",
      value: "0",
      showContent: false,
      content: (
        <OverviewAnalyticsProvider
          selectedBusinessUnit={selectedBusinessUnit}
          selectedFilterCurrency={selectedFilterCurrency}
          selectedDropdownValue={selectedDropdownValue}
          refresh={refresh}
          singleStartDate={singleStartDate}
          startDate={startDate}
          endDate={endDate}
        />
      ),
    },
    {
      label: "Checkout",
      value: "1",
      showContent: false,
      isVisible: false,
      isHidden: process.env?.REACT_APP_CHECKOUT_ENABLE === "false",
      content: (
        <ChekoutAnalyticsProvider
          selectedBusinessUnit={selectedBusinessUnit}
          selectedFilterCurrency={selectedFilterCurrency}
          selectedDropdownValue={selectedDropdownValue}
          refresh={refresh}
          singleStartDate={singleStartDate}
          startDate={startDate}
          endDate={endDate}
        />
      ),
    },
    {
      label: "Refund",
      value: "2",
      showContent: false,
      content: (
        <RefundAnalyticsProvider
          selectedBusinessUnit={selectedBusinessUnit}
          selectedFilterCurrency={selectedFilterCurrency}
          selectedDropdownValue={selectedDropdownValue}
          refresh={refresh}
          singleStartDate={singleStartDate}
          startDate={startDate}
          endDate={endDate}
        />
      ),
    },
    // {
    //   label: "Payment Link",
    //   value: "3",
    //   showContent: false,
    //   content: (
    //     <PaymentLinkAnalyticsProvider
    //       selectedBusinessUnit={selectedBusinessUnit}
    //       selectedFilterCurrency={selectedFilterCurrency}
    //       selectedDropdownValue={selectedDropdownValue}
    //       refresh={refresh}
    //       singleStartDate={singleStartDate}
    //       startDate={startDate}
    //       endDate={endDate}
    //     />
    //   ),
    // },
    // {
    //   label: "Offers",
    //   value: "4",
    //   showContent: false,
    //   content: (
    //     <OffersAnalyticsProvider
    //       selectedBusinessUnit={selectedBusinessUnit}
    //       selectedFilterCurrency={selectedFilterCurrency}
    //       selectedDropdownValue={selectedDropdownValue}
    //       refresh={refresh}
    //       singleStartDate = { singleStartDate }
    //     />
    //   ),
    // },
  ];

  return (
    <>
      <AnalyticsContext.Provider value={selectedDropdownValue}>
        <RefreshContext.Provider value={refresh}>
          <div className="content-wrapper" style={{ backgroundColor: "white" }}>
            <section className="content">
              <div
                style={{
                  width: "100%",
                }}
              >
                <DownloadAndDropdown
                  showDropdown={showDropdown}
                  showDownloadIcon={showDownloadIcon}
                  showRefreshIcon={showRefreshIcon}
                  handleDropdownChange={handleDropdownChange}
                  handleRefreshChange={handleRefreshButton}
                  showBusinessUnit={showBusinessUnit}
                  handleBussinessUnitChange={handleBussinessUnitChange}
                  handleCurrencyFilterChange={handleCurrencyFilterChange}
                  showCurrency={showCurrency}
                  currency={filteredCurrency}
                  configPaymentData={configPaymentData}
                  setLoading={setLoading}
                  handleSingleStartDate={handleSingleStartDate}
                  handleStartDate={handleStartDate}
                  handleEndDate={handleEndDate}
                />
                <div style={{ marginTop: "-10px" }}>
                  <TabSchema tabs={analyticsTabs} tabKey="selectedTab1" />
                </div>
              </div>
            </section>
          </div>
        </RefreshContext.Provider>
      </AnalyticsContext.Provider>
    </>
  );
}
